// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__30-d-","amount":"Amount_amount__1zFLe","tip":"Amount_tip__3yT1J","tipHeader":"Amount_tipHeader__1cVm-","tipsWrap":"Amount_tipsWrap__1Z3Dk"};